import { createAction } from 'redux-actions';

const actions = {
  /**
   *  추천 기획전 데이터 변경하기
   */
  SET_DATA: 'recommend/event/SET_DATA',
  setData: createAction('recommend/event/SET_DATA'),

  /**
   *  추천 기획전 리스트 가져오기
   */
  GET_RECOMMEND_EVENT_LIST_REQUEST: 'recommend/event/GET_RECOMMEND_EVENT_LIST_REQUEST',
  GET_RECOMMEND_EVENT_LIST_SUCCESS: 'recommend/event/GET_RECOMMEND_EVENT_LIST_SUCCESS',
  getRecommendEventList: createAction('recommend/event/GET_RECOMMEND_EVENT_LIST_REQUEST'),

  /**
   *  추천 기획전 상세 요청하기
   */
  GET_RECOMMEND_EVENT_DETAIL_REQUEST: 'recommend/event/GET_RECOMMEND_EVENT_DETAIL_REQUEST',
  GET_RECOMMEND_EVENT_DETAIL_SUCCESS: 'recommend/event/GET_RECOMMEND_EVENT_DETAIL_SUCCESS',
  getRecommendEventDetail: createAction('recommend/event/GET_RECOMMEND_EVENT_DETAIL_REQUEST'),

  /**
   *  추천 기획전 복사하기 전 필요한 데이터 가져오기
   */
  PREPARE_COPY_RECOMMEND_EVENT_REQUEST: 'recommend/event/PREPARE_COPY_RECOMMEND_EVENT_REQUEST',
  PREPARE_COPY_RECOMMEND_EVENT_SUCCESS: 'recommend/event/PREPARE_COPY_RECOMMEND_EVENT_SUCCESS',
  prepareCopyRecommendEvent: createAction('recommend/event/PREPARE_COPY_RECOMMEND_EVENT_REQUEST'),

  /**
   *  추천 기획전 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_CREATE_RECOMMEND_EVENT_REQUEST: 'recommend/event/PREPARE_CREATE_RECOMMEND_EVENT_REQUEST',
  PREPARE_CREATE_RECOMMEND_EVENT_SUCCESS: 'recommend/event/PREPARE_CREATE_RECOMMEND_EVENT_SUCCESS',
  prepareCreateRecommendEvent: createAction('recommend/event/PREPARE_CREATE_RECOMMEND_EVENT_REQUEST'),

  /**
   *  추천 기획전에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_EVENT_ITEM_REQUEST: 'recommend/event/GET_RECOMMEND_EVENT_ITEM_REQUEST',
  GET_RECOMMEND_EVENT_ITEM_SUCCESS: 'recommend/event/GET_RECOMMEND_EVENT_ITEM_SUCCESS',
  getRecommendEventItemList: createAction('recommend/event/GET_RECOMMEND_EVENT_ITEM_REQUEST'),

  /**
   *  추천 기획전 등록/복사하기
   */
  CREATE_RECOMMEND_EVENT_REQUEST: 'recommend/event/CREATE_RECOMMEND_EVENT_REQUEST',
  createRecommendEvent: createAction('recommend/event/CREATE_RECOMMEND_EVENT_REQUEST'),

  /**
   *  전체 기획전 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/event/GET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getRecommendEventItemListExcelDownload: createAction(
    'recommend/event/GET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  선택된 기획전 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/event/GET_SELECTED_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedRecommendEventItemListExcelDownload: createAction(
    'recommend/event/GET_SELECTED_RECOMMEND_EVENT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  기획전 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_REQUEST:
    'recommend/event/SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_SUCCESS: 'recommend/event/SET_RECOMMEND_EVENT_ITEM_EXCEL_UPLOAD_SUCCESS',
  setRecommendEventItemListExcelUpload: createAction(
    'recommend/event/SET_RECOMMEND_EVENT_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  ),
};

export default actions;
